/** @format */

import { type HTMLAttributes, type ReactNode } from 'react';
import { Container } from '../container';

type WelcomeTitleProps = HTMLAttributes<HTMLHeadingElement> & {
  children?: ReactNode;
};

export const WelcomeTitle = (props: WelcomeTitleProps) => {
  const { children, ...rest } = props;
  return (
    <Container>
      <h2 className="welcome-title" {...rest}>
        {children}
      </h2>{' '}
    </Container>
  );
};
